import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import {
  Table,
  ButtonGroup,
  IconButton,
  Icon,
  Panel,
  Row,
  Form,
  Col,
  Grid,
  Avatar,
  Input,
  ControlLabel,
  Button,
} from 'rsuite'
import pathname from '../../../constants/pathname'
import AppContext from '../../../context/AppContext'
import { getAllProject, getTest } from '../../../redux/actions/dashboard'
import '../styles.less'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import TooltipButton from '../../../components/buttons/TooltipButton'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import SearchButton from '../../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import CommitteeEditDetailWidget from '../../../widgets/admin/manage/CommitteeEditDetailWidget'

export default function CommitteeDataTable({
  schema,
  pagination,
  onReload,
  loading,
  hiddenColStatus,
  onSearchCommittee,
  onEdit,
  onRemove,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const history = useHistory()
  const [selectList, setSelectList] = useState([])
  const [isError, setIsError] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [deleteObj, setDeleteObj] = useState({})
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const contextValue = React.useContext(AppContext)
  const [tableData, setTableData] = useState([])
  const [inputValueAccountName, setInputValueAccountName] = useState('')
  const [inputValueAccountYear, setInputValueAccountYear] = useState('')
  const [inputValueRole, setInputValueRole] = useState('')
  const [inputValueDepartment, setInputValueDepartment] = useState('')

  useEffect(() => {
    if (pagination && typeof onReload !== 'function') {
      setTableData(getData())
    } else if (schema.values) {
      setTableData(schema.values)
    } else {
      setTableData([])
    }
  }, [schema, pagination, onReload])

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const getIcon = (key) => {
    if (key == 1) {
      return 'file-o'
    } else if (key == 2) {
      return 'copy-o'
    } else if (key == 3) {
      return 'building2'
    }
  }

  const handleChangeLength = (dataKey) => {
    // console.log('handleChangeLength dataKey', dataKey)
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(dataKey, 1, inputValueAccountName, inputValueAccountYear)
    }
  }

  const handleChangePage = (dataKey) => {
    // console.log('handleChangePage page', dataKey)

    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(displayLength, dataKey, inputValueAccountName, inputValueAccountYear)
    }
  }

  const getData = () => {
    return schema.values?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  const handleSearchCommittee = () => {
    onSearchCommittee(5, 1, inputValueAccountName, inputValueAccountYear)
    setPage(1)
  }

  const handleCancelSearchCommittee = () => {
    setInputValueAccountName('')
    setInputValueAccountYear('')
    onSearchCommittee(5, 1, '', '', '', '')
    setPage(1)
  }

  const onDelete = (rowData) => {
    setIsShowConfirm(true)
    setDeleteObj(rowData)
  }

  const SubnameCell = ({ rowData, dataKey, ...props }) => {
    let _color = ''
    if (schema.header === 'โครงการทั้งหมด') {
      _color = '#ff0000'
    } else {
      _color = '#ff9800'
    }

    return (
      <Cell {...props}>
        <Grid fluid>
          <Row>
            <Col lg={24} md={24} sm={24} xs={24}>
              {rowData[dataKey].name || rowData[dataKey]}
            </Col>
            <Col lg={24} md={24} sm={24} xs={24} style={{ fontSize: 10, color: _color }}>
              {rowData[dataKey].statusName && (
                <>
                  <Icon icon="exclamation-circle2" size="lg" />
                  &nbsp;&nbsp;
                  {rowData[dataKey].statusName}
                </>
              )}
            </Col>
          </Row>
        </Grid>
      </Cell>
    )
  }

  const ImageCell = ({ rowData, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0, marginTop: 8 }}>
      <Grid fluid>
        <Row>
          <Col
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{
              width: 40,
              height: 40,
              background: contextValue.theme[0] == 'dark' ? '#515151' : '#f5f5f5',
              borderRadius: 20,
              marginTop: 2,
              overflow: 'hidden',
              display: 'inline-block',
            }}
          >
            <Icon
              icon={rowData[dataKey].icon}
              size={'lg'}
              style={{ marginLeft: 6, marginTop: 10 }}
            />
          </Col>
          <Col lg={12} md={12} sm={12} xs={12} style={{ marginTop: 10 }}>
            {rowData[dataKey].label || rowData[dataKey].projectType}
          </Col>
        </Row>
      </Grid>
    </Cell>
  )

  const TagCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell {...props} style={{ padding: 13 }}>
        <div
          className="tag"
          style={{
            backgroundColor: rowData[dataKey].code || '',
          }}
        >
          <span className="tag__text">{rowData[dataKey].label}</span>
        </div>
      </Cell>
    )
  }

  return (
    <>
      {schema?.searchPanel && (
        <Panel header={schema.searchPanel.header} bordered collapsible shaded defaultExpanded>
          <Grid fluid>
            {/* <Form fluid> */}
            <Row>
              <Col xs={24} sm={12} md={12} lg={6} style={{ marginBottom: 5 }}>
                <ControlLabel>{schema.searchPanel.accountName.label}</ControlLabel>
                <Input
                  style={{ width: '100%' }}
                  name={schema.searchPanel.accountName.name}
                  value={inputValueAccountName}
                  //defaultValue={schema.searchPanel.name.value}
                  onChange={(value) => setInputValueAccountName(value)}
                  placeHolder={schema.searchPanel.accountName.hint}
                ></Input>
              </Col>
              <Col xs={24} sm={12} md={12} lg={6} style={{ marginBottom: 5 }}>
                <ControlLabel>{schema.searchPanel.accountYear.label}</ControlLabel>
                <Input
                  style={{ width: '100%' }}
                  name={schema.searchPanel.accountYear.name}
                  value={inputValueAccountYear}
                  //defaultValue={schema.searchPanel.accountYear.value}
                  onChange={(value) => setInputValueAccountYear(value)}
                  placeHolder={schema.searchPanel.accountYear.hint}
                ></Input>
              </Col>
            </Row>
            <Row>
              <div>
                <br />
                <SearchButton onClick={handleSearchCommittee}>ค้นหา</SearchButton>
                <CancelButton onClick={handleCancelSearchCommittee}>ยกเลิก</CancelButton>
              </div>
            </Row>
            {/* </Form> */}
          </Grid>
        </Panel>
      )}
      <br />
      <CommitteeEditDetailWidget
        schema={schema.forms}
        isAddPanel={true}
        onAddSuccess={(res) => setTableData(res.values)}
      />
      <br />
      <Panel
        header={schema?.header}
        bordered
        collapsible
        shaded
        defaultExpanded
        className="table-all-project"
      >
        <Table
          wordWrap
          height={400}
          loading={loading}
          data={tableData}
          style={{ marginTop: '20px' }}
        >
          <Column align="center" width={60} fixed>
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell dataKey="numberOfSequence" />
          </Column>

          <Column minWidth={200} flexGrow={3}>
            <HeaderCell>ชื่อบัญชีคณะกรรมการ</HeaderCell>
            <Cell dataKey="accountTypeName" />
          </Column>

          <Column minWidth={100} flexGrow={1}>
            <HeaderCell>ปีงบประมาณ</HeaderCell>
            <Cell dataKey="accountYear" />
          </Column>

          <Column width={200} align="center" fixed="right">
            <HeaderCell>จัดการ</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <ButtonGroup>
                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-edit"
                      icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                      onClick={() => onEdit(rowData)}
                    >
                      แก้ไข
                    </IconButton>
                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-cancel"
                      icon={<Icon icon="trash" className="bt-gost-icon-none-radius-cancel" />}
                      onClick={() => onDelete(rowData)}
                    >
                      ลบ
                    </IconButton>
                  </ButtonGroup>
                )
              }}
            </Cell>
          </Column>
        </Table>

        {pagination && (
          <TablePagination
            lengthMenu={defaultLengthMenu}
            activePage={page || defaultPage}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total} รายการ`}</>
            }}
            displayLength={displayLength || 5}
            total={schema.totalSize || 0}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        )}

        {schema?.message && (
          <Row>
            <Message showIcon type={schema.message.type} description={schema.message.message} />
          </Row>
        )}

        <ConfirmWidget
          title={`ยืนยันการลบรายการ`}
          show={isShowConfirm}
          detail={`ยืนยันการลบ ${
            deleteObj?.projectName ? schema.projectNameText + ' : ' + deleteObj.projectName : ''
          }`}
          onCancle={() => {
            setIsShowConfirm(false)
            setDeleteObj({})
          }}
          onConfirm={() => {
            onRemove(deleteObj)
            let total = schema.values.length
            let newPage = Math.ceil(total / displayLength)
            if (newPage > 0 && newPage < page) {
              setPage(newPage)
            }
            setIsShowConfirm(false)
          }}
        />
      </Panel>
    </>
  )
}
